<template>
  <div class="current-clinic-section">
    <!-- Clinic Icon & Info -->
    <div class="clinic-icon-wrapper">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.3334 8V12H21.3334V14.6667H17.3334V18.6667H14.6667V14.6667H10.6667V12H14.6667V8H17.3334ZM24 13.6C24 8.76 20.4667 5.33334 16 5.33334C11.5334 5.33334 8.00004 8.76 8.00004 13.6C8.00004 16.72 10.6 20.8533 16 25.7867C21.4 20.8533 24 16.72 24 13.6ZM16 2.66667C21.6 2.66667 26.6667 6.96 26.6667 13.6C26.6667 18.0267 23.1067 23.2667 16 29.3333C8.89337 23.2667 5.33337 18.0267 5.33337 13.6C5.33337 6.96 10.4 2.66667 16 2.66667Z" fill="#374957"/>
        </svg>
    </div>

    <div class="clinic-info">
      <h2 class="clinic-name">{{ clinicName }}</h2>
      <div class="clinic-meta">
        <span class="meta-item">{{ clinicAddress }}</span>
        <span v-if="clinicPhone" class="meta-separator"></span>
        <span v-if="clinicPhone" class="meta-item meta-phone">{{ clinicPhone }}</span>
      </div>
    </div>

    <!-- Controls Section -->
    <div class="clinic-controls">
      <!-- Time Range Filter -->
      <div class="control-group" style="min-width: 200px">
        <Label label="Time Range">
          <template #icon>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M7 11H9V13H7V11ZM21 6V20C21 21.1 20.1 22 19 22H5C3.89 22 3 21.1 3 20L3.01 6C3.01 4.9 3.89 4 5 4H6V2H8V4H16V2H18V4H19C20.1 4 21 4.9 21 6ZM5 8H19V6H5V8ZM19 20V10H5V20H19ZM15 13H17V11H15V13ZM11 13H13V11H11V13Z" fill="#374957"/>
            </svg>
          </template>
          <!-- Show selector when not in Custom mode OR when Custom with dates selected -->
          <SingleSelector v-if="!showDatePicker" v-model="selectedTimeRange" :options="timeRangeOptions" size="medium" />
          <!-- Show date picker when Custom is selected and no dates chosen yet -->
          <el-date-picker
            v-else
            v-model="customDateRange"
            type="daterange"
            range-separator="-"
            start-placeholder="Start Date"
            end-placeholder="End Date"
            size="default"
            format="MMM DD, YYYY"
            value-format="YYYY-MM-DDTHH:mm:ss.SSSZ"
            class="control-select"
            :disabledDate="disableFutureDates"
            @change="onCustomDateChange"
          />
        </Label>
        <!-- <label class="control-label">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M7 11H9V13H7V11ZM21 6V20C21 21.1 20.1 22 19 22H5C3.89 22 3 21.1 3 20L3.01 6C3.01 4.9 3.89 4 5 4H6V2H8V4H16V2H18V4H19C20.1 4 21 4.9 21 6ZM5 8H19V6H5V8ZM19 20V10H5V20H19ZM15 13H17V11H15V13ZM11 13H13V11H11V13Z" fill="#374957"/>
          </svg>
          <span>Time Range</span>
        </label> -->
        
        <!-- Show selector when not in Custom mode OR when Custom with dates selected -->
        <!-- <SimpleSelector
          v-if="!showDatePicker"
          :current-element-type="selectedTimeRange"
          :elements="timeRangeOptions"
          @element-selected="onTimeRangeSelected"
        /> -->
      </div>

      <!-- Dashboard Scope (Admin only) -->
      <div style = "min-width: 285px;">
        <Label label="Dashboard Scope">
          <template #icon>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H17.27L19 17.27V19ZM19 16H18.15L15.15 19H13.53L16.53 16H14.41L11.41 19H9.8L12.8 16H10.68L7.68 19H5.84L8.84 16H6.72L5 17.72V5H19V16Z" fill="#374957"/>
              <path d="M10.67 11L12.67 13L17.75 7.91L16.34 6.5L12.67 10.17L10.67 8.17L6.25 12.59L7.66 14L10.67 11Z" fill="#374957"/>
            </svg>
          </template>
          <SingleSelector v-model="selectedScope" :options="scopeOptions" size="medium" />
        </Label>
      </div>
      <!-- <div class="control-group">
        <label class="control-label">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H17.27L19 17.27V19ZM19 16H18.15L15.15 19H13.53L16.53 16H14.41L11.41 19H9.8L12.8 16H10.68L7.68 19H5.84L8.84 16H6.72L5 17.72V5H19V16Z" fill="#374957"/>
            <path d="M10.67 11L12.67 13L17.75 7.91L16.34 6.5L12.67 10.17L10.67 8.17L6.25 12.59L7.66 14L10.67 11Z" fill="#374957"/>
          </svg>
          <span>Dashboard Scope</span>
        </label>
        <SimpleSelector
          :current-element-type="selectedScope"
          :elements="scopeOptions"
          @element-selected="onScopeSelected"
        />
      </div> -->

      <!-- View As (Role Switcher) -->
      <div class="control-group view-as-control">
        <label class="control-label">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M4 13C5.1 13 6 12.1 6 11C6 9.9 5.1 9 4 9C2.9 9 2 9.9 2 11C2 12.1 2.9 13 4 13ZM5.13 14.1C4.76 14.04 4.39 14 4 14C3.01 14 2.07 14.21 1.22 14.58C0.48 14.9 0 15.62 0 16.43V18H4.5V16.39C4.5 15.56 4.73 14.78 5.13 14.1ZM20 13C21.1 13 22 12.1 22 11C22 9.9 21.1 9 20 9C18.9 9 18 9.9 18 11C18 12.1 18.9 13 20 13ZM24 16.43C24 15.62 23.52 14.9 22.78 14.58C21.93 14.21 20.99 14 20 14C19.61 14 19.24 14.04 18.87 14.1C19.27 14.78 19.5 15.56 19.5 16.39V18H24V16.43ZM16.24 13.65C15.07 13.13 13.63 12.75 12 12.75C10.37 12.75 8.93 13.14 7.76 13.65C6.68 14.13 6 15.21 6 16.39V18H18V16.39C18 15.21 17.32 14.13 16.24 13.65ZM8.07 16C8.16 15.77 8.2 15.61 8.98 15.31C9.95 14.93 10.97 14.75 12 14.75C13.03 14.75 14.05 14.93 15.02 15.31C15.79 15.61 15.83 15.77 15.93 16H8.07ZM12 8C12.55 8 13 8.45 13 9C13 9.55 12.55 10 12 10C11.45 10 11 9.55 11 9C11 8.45 11.45 8 12 8ZM12 6C10.34 6 9 7.34 9 9C9 10.66 10.34 12 12 12C13.66 12 15 10.66 15 9C15 7.34 13.66 6 12 6Z" fill="#374957"/>
          </svg>
          <span>View As</span>
        </label>
        <div class="view-as-tag" v-if="isAdmin">
          <span>Admin</span>
        </div>
        <div class="view-as-tag static" v-else>
          <span>Provider</span>
        </div>
      </div>

      <!-- AI Insight Button -->
      <div class="ai-insight-btn-wrapper" 
        @mouseenter="handleMouseEnterAIInsightBtn"
        @mouseleave="handleMouseLeaveAIInsightBtn"
        @click="toggleAIPanel">
        <div
          class="ai-insight-btn" 
          :class="{ active: aiPanelOpen }"
        >
          <svg v-if="!aiPanelOpen" class="ai-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M19 9L20.25 6.25L23 5L20.25 3.75L19 1L17.75 3.75L15 5L17.75 6.25L19 9Z" fill="#004879"/>
            <path d="M19 15L17.75 17.75L15 19L17.75 20.25L19 23L20.25 20.25L23 19L20.25 17.75L19 15Z" fill="#004879"/>
            <path d="M11.5 9.5L9 4L6.5 9.5L1 12L6.5 14.5L9 20L11.5 14.5L17 12L11.5 9.5ZM9.99 12.99L9 15.17L8.01 12.99L5.83 12L8.01 11.01L9 8.83L9.99 11.01L12.17 12L9.99 12.99Z" fill="#004879"/>
          </svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M22 3.41L16.71 8.7L20 12H12V4L15.29 7.29L20.59 2L22 3.41ZM3.41 22L8.7 16.71L12 20V12H4L7.29 15.29L2 20.59L3.41 22Z" fill="white"/>
          </svg>
          <span v-if="!aiPanelOpen" :class="['ai-insight-text', { 'show': showAIInsight }]">AI Insights</span>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, nextTick } from 'vue';
import { useStore } from 'vuex';
import SimpleSelector from '@/views/commonComponents/SimpleSelector.vue';

const store = useStore();
const showAIInsight = ref(false);

const dashboardFilters = computed(() => store.state.myPractice.clinicDashboard.dashboardFilters);
const aiPanelOpen = computed(() => store.state.myPractice.clinicDashboard.aiPanelOpen);
const isAdmin = computed(() => store.getters['login/isAdmin']);

const providersList = computed(() => store.state.myPractice.clinicDashboard.providersList);

const clinicInfo = computed(() => store.getters['myPractice/clinicDashboard/currentClinicInfo']);
const clinicName = computed(() => clinicInfo.value?.practice_name || '');
const clinicAddress = computed(() => {
  const addr = clinicInfo.value?.office_address;
  if (!addr?.city) return '';
  return [addr.address_line_1, addr.city, addr.state].filter(Boolean).join(', ');
});
const clinicPhone = computed(() => clinicInfo.value?.contact_info?.primary_phone || '');

const selectedTimeRange = ref(dashboardFilters.value.timeRange);
const selectedScope = ref(isAdmin.value ? dashboardFilters.value.dashboardScope : store.state?.login?.userInfo?.customer_id);
const customDateRange = ref(null);
const showDatePicker = ref(false);

// Restore custom date range from store on mount
onMounted(() => {
  const filters = dashboardFilters.value;
  if (filters.timeRange === 'custom' && filters.startDate && filters.endDate) {
    customDateRange.value = [filters.startDate, filters.endDate];
    showDatePicker.value = false;
  }
});

const customRangeLabel = computed(() => {
  if (customDateRange.value && customDateRange.value.length === 2) {
    const startDate = new Date(customDateRange.value[0]);
    const endDate = new Date(customDateRange.value[1]);
    const formatDate = (date) => {
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const year = String(date.getFullYear()).slice(-2);
      return `${month}/${day}/${year}`;
    };
    return `${formatDate(startDate)} - ${formatDate(endDate)}`;
  }
  return 'Custom Range';
});

// Unique key per date selection so clicking "Custom Range" always triggers a change
const customRangeKey = computed(() => {
  if (customDateRange.value && customDateRange.value.length === 2) {
    return `custom_${customDateRange.value[0]}_${customDateRange.value[1]}`;
  }
  return null;
});

const timeRangeOptions = computed(() => {
  const options = [
    { value: 'last_7_days', label: 'Last 7 Days', iconSvg: '' },
    { value: 'last_30_days', label: 'Last 30 Days', iconSvg: '' },
    { value: 'last_90_days', label: 'Last 90 Days', iconSvg: '' },
    { value: 'last_year', label: 'Last Year', iconSvg: '' },
  ];
  if (customRangeKey.value) {
    options.push({ value: customRangeKey.value, label: customRangeLabel.value, iconSvg: '' });
  }
  options.push({ value: 'custom', label: 'Custom Range', iconSvg: '' });
  return options;
});

const scopeOptions = computed(() => {
  return isAdmin.value 
  ? [
    { value: 'all', label: 'Practice View (All Providers)' },
    ...providersList.value.map(provider => ({
      value: provider.customer_id,
      label: formatProviderName(provider),
    }))
  ] 
  : [
    { 
      value: store.state?.login?.userInfo?.customer_id, 
      label: store.state?.login?.userInfo?.customer_name || 'Current Provider', 
    }
  ];
});

// Guard to skip @change re-emit when syncing from store
let isSyncingFromStore = false;

watch(() => dashboardFilters.value.timeRange, (val) => {
  isSyncingFromStore = true;
  if (val === 'custom') {
    const filters = dashboardFilters.value;
    if (filters.startDate && filters.endDate) {
      customDateRange.value = [filters.startDate, filters.endDate];
      selectedTimeRange.value = `custom_${filters.startDate}_${filters.endDate}`;
      showDatePicker.value = false;
    } else {
      selectedTimeRange.value = 'custom';
    }
  } else {
    selectedTimeRange.value = val;
  }
  nextTick(() => { isSyncingFromStore = false; });
});

// Watch local ref → dispatch to store (skips when syncing from store)
watch(() => selectedTimeRange.value, (val) => {
  if (isSyncingFromStore) return;
  if (val === 'custom') {
    showDatePicker.value = true;
    return;
  }
  // Custom key changes are handled by onCustomDateChange
  if (typeof val === 'string' && val.startsWith('custom_')) {
    return;
  }
  showDatePicker.value = false;
  customDateRange.value = null;
  store.dispatch('myPractice/clinicDashboard/updateFilters', { timeRange: val, startDate: null, endDate: null });
});

watch(() => dashboardFilters.value.dashboardScope, (val) => {
  isSyncingFromStore = true;
  selectedScope.value = val;
  nextTick(() => { isSyncingFromStore = false; });
});

watch(() => selectedScope.value, (val) => {
  if (isSyncingFromStore) return;
  store.dispatch('myPractice/clinicDashboard/updateFilters', { dashboardScope: val });
});

function handleMouseEnterAIInsightBtn() {
  setTimeout(() => {
    showAIInsight.value = true;
  }, 400);
}

function handleMouseLeaveAIInsightBtn() {
  setTimeout(() => {
    showAIInsight.value = false;
  }, 400);
}

function onCustomDateChange(val) {
  if (val && val.length === 2) {
    showDatePicker.value = false;
    customDateRange.value = val;
    selectedTimeRange.value = `custom_${val[0]}_${val[1]}`;
    store.dispatch('myPractice/clinicDashboard/updateFilters', {
      timeRange: 'custom',
      startDate: val[0],
      endDate: val[1],
    });
  }
}

function disableFutureDates(date) {
  return date > new Date();
}

function formatProviderName(provider) {
  return [provider.customer_first_name, provider.customer_middle_name, provider.customer_last_name]
    .filter(Boolean)
    .join(' ');
}

function toggleAIPanel() {
  store.dispatch('myPractice/clinicDashboard/toggleAIPanel');
}
</script>

<style scoped>
.current-clinic-section {
  display: flex;
  align-items: center;
  gap: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #c4c4c4;
}

/* Clinic Icon */
.clinic-icon-wrapper {
  width: 54px;
  height: 54px;
  background: #f2f2f2;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 4px;
  flex-shrink: 0;
}

.clinic-icon-img {
  width: 32px;
  height: 32px;
  object-fit: contain;
}

/* Clinic Info */
.clinic-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.clinic-name {
  font-family: 'Avenir', sans-serif;
  font-size: 22px;
  font-weight: 500;
  line-height: 24px;
  color: #333;
  margin: 0;
}

.clinic-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
}

.meta-item {
  color: #333;
}

.meta-phone,
.meta-specialty {
  color: #666;
}

.meta-separator {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #666;
  flex-shrink: 0;
}

/* Controls Section */
.clinic-controls {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 68px;
  width: fit-content;
  flex-shrink: 0;
}

.control-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.view-as-control {
  flex: 0 0 112px;
}

.control-label {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 24px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #4a4a4a;
}

.label-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.control-select {
  width: 100%;
}

/* View As Tag */
.view-as-tag {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  cursor: pointer;
  transition: background 0.2s;
}

.view-as-tag.static {
  cursor: default;
}

.view-as-tag:hover span {
  background: #b5c7db;
}

.view-as-tag.static:hover span{
  background: #c5d7eb;
}

.view-as-tag span {
  padding:4px 16px;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.15px;
  color: #374957;
  background: #c5d7eb;
  border-radius: 20px;
  transition: background 0.2s;
}

/* AI Insight Button */
.ai-insight-btn-wrapper {
  height:64px;
  width:fit-content;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.ai-insight-btn {
  width: 56px;
  height: 56px;
  border-radius: 100px;
  box-shadow: 0 1px 3px 0 rgba(74, 74, 74, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  transition: width 0.3s ease, height 0.3s ease, padding 0.3s ease;
  position: relative;
  overflow: hidden;
}

/* Background gradient layer */
.ai-insight-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(87deg, #C9D8F2 -72.9%, #F8E9E0 -15.92%, #D5E2F4 29.87%, #CABEE2 84.7%, #C9D8F2 144.61%);
  border-radius: 100px;
  z-index: 0;
}

/* Step 1: On hover, rotate background and grow button */
.ai-insight-btn:hover::before {
  transform: rotate(180deg);
  transition: transform 0.3s ease;
}

.ai-insight-btn:hover {
  width: 64px;
  height: 64px;
}

/* Icon transitions */
.ai-icon {
  position: relative;
  z-index: 1;
  width: 24px;
  height: 24px;
  transition: width 0.3s ease, height 0.3s ease;
}

.ai-insight-btn:hover .ai-icon {
  width: 32px;
  height: 32px;
}

/* Step 2: When text appears, adjust button size and icon */
.ai-insight-btn:has(.ai-insight-text.show) {
  width: fit-content;
  height: fit-content;
  padding: 8px 16px;
}

.ai-insight-btn:has(.ai-insight-text.show)::before {
  background: linear-gradient(87deg, #C9D8F2 -72.9%, #D5E2F4 29.87%, #CABEE2 84.7%, #C9D8F2 144.61%);
  transform: rotate(180deg);
}

.ai-insight-btn:has(.ai-insight-text.show) .ai-icon {
  width: 22px;
  height: 22px;
}

/* Text styling */
.ai-insight-text {
  position: relative;
  z-index: 1;
  color: #004879;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.15px;
  white-space: nowrap;
  opacity: 0;
  max-width: 0;
  overflow: hidden;
  transition: opacity 0.3s ease 0.3s, max-width 0.3s ease 0.3s;
}

.ai-insight-text.show {
  opacity: 1;
  max-width: 200px;
}

/* Active state (when panel is open) */
.ai-insight-btn.active {
  width: 42px;
  height: 42px;
  background: #004879;
}

.ai-insight-btn.active::before {
  display: none;
}

.ai-insight-btn.active .ai-icon {
  width: 24px;
  height: 24px;
}

/* Element Plus Overrides */
:deep(.el-select) {
  height: 40px;
}

:deep(.el-input__wrapper) {
  border: 1px solid #c4c4c4;
  border-radius: 4px;
  background: white;
  box-shadow: none;
  height: 40px;
}

:deep(.el-input__wrapper:hover) {
  box-shadow: none;
}

:deep(.el-input__wrapper.is-focus) {
  box-shadow: none;
  border-color: #004879;
}

:deep(.el-input__inner) {
  font-family: 'IBM Plex Sans Hebrew', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: #333;
}

:deep(.el-date-editor) {
  height: 40px;
}

:deep(.el-range-input) {
  font-family: 'IBM Plex Sans Hebrew', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15px;
}
</style>
